import {
  UpdateHistoryAction,
  IHistory
} from "../../types/redux/breadcrumb";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export const historySlice = createSlice({
  name: UpdateHistoryAction,
  initialState: {
    history: []
  },
  reducers: {
    addToHistory: (state: IHistory, action: PayloadAction<string>) => {
      state.history.push(action.payload)
    }
  }
});

export const {
  addToHistory
} = historySlice.actions;

export default historySlice.reducer;
